import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Instant-save toggle for the Badges "Badge Alert Email Notifications" pref.
// On failure it reverts the switch so the UI never misrepresents the saved state.
export default class extends Controller {
  static targets = ["checkbox", "status"]
  static values = { url: String }

  async save() {
    const enabled = this.checkboxTarget.checked
    this.setStatus("Saving…")
    this.checkboxTarget.disabled = true

    const body = new FormData()
    body.append("user[notify_badge_email]", enabled ? "1" : "0")

    try {
      const response = await patch(this.urlValue, { body, responseKind: "json" })
      if (response.ok) {
        this.setStatus(enabled ? "Email alerts on" : "Email alerts off")
      } else {
        this.revert(enabled)
      }
    } catch {
      this.revert(enabled)
    } finally {
      this.checkboxTarget.disabled = false
    }
  }

  revert(attempted) {
    this.checkboxTarget.checked = !attempted
    this.setStatus("Couldn't save — try again")
  }

  setStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
